module.exports = __webpack_public_path__ + "612812748f16b0927241546c39b09a02.pdf";